<div class="session-rewards-container">
  <app-rewards-grid
    #rewardsGrid
    [config]="rewardsGridConfig"
    [title]="title"
    [rewardsService]="sessionRewardsService"
    (onExport)="onExport($event)"
    (onPayment)="onPayment($event)"
    (onAddReward)="onAddReward($event)"
    (onViewLedger)="onViewLedger($event)"
    (onDataChange)="onDataChange($event)"
    (onFilterChange)="onFilterChange($event)"
  ></app-rewards-grid>
</div>